import styled from "@emotion/styled";
import WebpImage from "@src/component/base/WebpImage";
import { GroupA } from "@src/ruix";

export const MainFooter = () => {
	const a = 1;
	return (
		<MainFooterContainer className="row-center-center">
			<div
				className="column-start-start"
				style={{
					width: "100%",
					maxWidth: "944px",
				}}
			>
				<GroupA order="row-start-between" fullWidth gap={40}>
					<GroupA order="column-start-start" gap={10}>
						<FooterTitle>주식회사 롸잇</FooterTitle>
						<FooterSubTitle>탑티어 마케터 파트타임 고용 서비스</FooterSubTitle>
					</GroupA>
					<GroupA order="row-start-between" gap={48}>
						<GroupA order="column-start-start" gap={20}>
							<FooterInfoTitle>COMPANY INFO</FooterInfoTitle>
							<GroupA order="column-start-start" gap={8}>
								<FooterSubTitle>대표자 | 최준순</FooterSubTitle>
								<FooterSubTitle>
									주소 | 서울특별시 강남구 테헤란로26길 14, 위워크빌딩 7층 106호
								</FooterSubTitle>
								<FooterSubTitle>이메일 | hello@1point.kr</FooterSubTitle>
							</GroupA>
						</GroupA>
						<GroupA order="column-start-start" gap={20}>
							<FooterInfoTitle>BUSINESS INFO</FooterInfoTitle>
							<GroupA order="column-start-start" gap={8}>
								<FooterSubTitle>사업자등록번호 | 466-87-02214</FooterSubTitle>
								<FooterSubTitle>통신판매업신고 | 2023-서울마포-0818</FooterSubTitle>
								<FooterSubTitle>개인정보관리책임자 | 강용진</FooterSubTitle>
							</GroupA>
						</GroupA>
					</GroupA>
				</GroupA>
				<GroupA order="column-start-start" gap={20}>
					<FooterInfoTitle>Backed by</FooterInfoTitle>
					<BackedByBox className="row-center-between">
						<WebpImage src="/onepoint/images/invest/mashup_white.png" alt="" />
						<WebpImage src="/onepoint/images/invest/sopoong_white.png" alt="" />
						<WebpImage src="/onepoint/images/invest/tips_logo.png" alt="" />
					</BackedByBox>
				</GroupA>
			</div>
		</MainFooterContainer>
	);
};

const BackedByBox = styled.div`
	gap: 20px;

	picture {
		width: 100px;

		img {
			width: 100%;
		}
	}
`;

const FooterInfoTitle = styled.div`
	color: #808da3;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 12px */
	letter-spacing: -0.4px;
`;

const FooterTitle = styled.div`
	color: #fff;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 28.8px */
	letter-spacing: -0.96px;
`;

const FooterSubTitle = styled.div`
	color: #fff;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 14.4px */
	letter-spacing: -0.48px;
`;

const MainFooterContainer = styled.div`
	min-height: 320px;
	background-color: var(--card-bg);
	padding-top: 40px;
	padding-left: 24px;
	padding-right: 24px;
	gap: 40px;
`;
